export const PaymentBlock = {
    props: ['financeValue', 'leaseValue', 'cashRebate', 'financeData', 'priceValue', 'msrpValue', 'salePrice', 'lang', 'provinceTax','frequencySelected'],
    data() {
      return {
        cashRebateValue: this.cashRebate,
        finance: this.financeValue,
        lease: this.leaseValue,
        provinceTaxValue: this.provinceTax ? (1 + (this.provinceTax / 100)) : 1.13,
        isLease: false,
        calculatedValue: 0,
        loanTerm: 0,
        downPayment: this.$cookies.get('downPayment'),
        tradeInValue: this.$cookies.get('tradeInValue'),
        frequency: this.frequencySelected ? this.frequencySelected : 'weekly',
        vehiclePrice: '' + (this.priceValue) + '',
        salesTax: 0,
        interestRate: 0,
        costOfBorrowing: 0,
        totalMSRP: this.msrpValue,
        termsMock: [
          { term: 12, value: 0 },
          { term: 24, value: 0 },
          { term: 36, value: 0 },
          { term: 48, value: 0 },
          { term: 60, value: 0 },
          { term: 72, value: 0 },
          { term: 84, value: 0 },
        ],
        kilometersAllowance: 25000,
      }
    },
  
    methods: {
      usdFormat(value) {
        var formatter = new Intl.NumberFormat(this.lang, {
          style: 'currency',
          currency: 'CAD',
          minimumFractionDigits: 2,
        });
  
        return formatter.format(value);
      },
      onFocus(value) {
        if (value == 'downPayment' && this.downPayment == 0){
          this.downPayment = '';
      }
        if (value == 'tradeInValue' && this.tradeInValue == 0){
          this.tradeInValue = '';
        }
      },
      blur(value) {
        if (value == 'downPayment' && this.downPayment == ''){
            this.downPayment = 0;
        }
        if (value == 'tradeInValue' && this.tradeInValue == ''){
          this.tradeInValue = 0;
        }
      },
      numberFormat(value) {
        return new Intl.NumberFormat(this.lang).format(value);
      },
      toggle: function () {
        this.isLease = !this.isLease
        this.loanTerm = this.termsOptions[this.termsOptions.length - 1];
        this.changeInterestRate();
        this.calculatePayment();
      },
      togglePlan: function (plan) {
        this.frequency = plan;
        this.calculatePayment();
      },
      close: function () {
        this.$emit('close');
      },
      calculatePayment: function () {
  
        if (this.isLease == true) {
          this.calculateLeasePayment();
  
        } else {
  
          var total = 0
          var term = 60
          if (this.loanTerm != 0)
            term = this.loanTerm;
          if (this.interestRate == 0)
            total = Math.round(((this.remainingVehiclePrice - this.residual) / term) * 100) / 100;
          else
            total = Math.round((((this.remainingVehiclePrice - this.residual) * (this.interestRate / 1200)) * Math.pow((1 + (this.interestRate / 1200)), term)) / (Math.pow((1 + (this.interestRate / 1200)), term) - 1) * 100) / 100;
  
          this.amountFinanced = (Math.round(total * term) * 100 / 100)
          this.costOfBorrowing = this.amountFinanced - this.remainingVehiclePrice;
          if (this.costOfBorrowing < 0)
            this.costOfBorrowing = 0;
  
          if (this.frequency == "weekly")
            this.calculatedValue = ((total * 12) / 52).toFixed(2);
          else if (this.frequency == "bi-weekly")
            this.calculatedValue = ((total * 12) / 26).toFixed(2);
          else
            this.calculatedValue = total.toFixed(2);
        }
        // alert("CALCULATE" + this.calculatedValue);
      },
      calculateLeasePayment: function () {
        var total = 0
        var depretation = ((this.remainingVehiclePrice - this.residual) / this.loanTerm)
        var moneyFactor = (this.interestRate / 2400)
        var financingFeeLease = ((this.residual + this.remainingVehiclePrice) * moneyFactor)
  
        total = financingFeeLease + depretation
  
        this.amountFinanced = this.remainingVehiclePrice - this.residual
        this.costOfBorrowing = ((total * this.loanTerm) - this.amountFinanced)
        if (this.costOfBorrowing < 0)
          this.costOfBorrowing = 0;
  
        if (this.frequency == "weekly")
          this.calculatedValue = ((total * 12) / 52).toFixed(2);
        else if (this.frequency == "bi-weekly")
          this.calculatedValue = ((total * 12) / 26).toFixed(2);
        else
          this.calculatedValue = (total).toFixed(2);
  
  
  
      },
      changeInterestRate() {
        this.setInterestRate();
        this.calculatePayment();
      },
      setInterestRate() {
        const index = this.terms.map(item => { return item.term }).indexOf(this.loanTerm);
        if (this.terms[index].value > 50)
          this.interestRate = parseFloat(Math.round(this.terms[index].value * 100) / 100) / 100;
        else
          this.interestRate = parseFloat(Math.round(this.terms[index].value * 100) / 100);
      }
    },
    computed: {
      leaseAdjustment() {
        if (!this.metadata)
          return 0;
  
        try {
          if(this.metadata.adjustments.adjustment){
              var optionIndex = this.metadata.adjustments.adjustment.map(item => { return item.mileage }).indexOf(this.kilometersAllowance)
              return this.metadata.adjustments.adjustment[optionIndex].adjustment;
          }else{
              var optionIndex = this.metadata.adjustments.map(item => { return item.mileage }).indexOf(this.kilometersAllowance)
              return this.metadata.adjustments[optionIndex].adjustment;
          }
  
        } catch (e) {
          return 0;
        }
      },
      hasKmsAllowance() {
        if (!this.metadata || !this.metadata.adjustments)
          return false;
        else
          return true;
      },
      metadata() {
        if (!this.isLease)
          return null;
  
        var optionIndex = this.lease.map(item => { return item.term }).indexOf(this.loanTerm);
        if (optionIndex == -1)
          return null;
        else
          try {
            return JSON.parse(this.lease[optionIndex].metadata) || null;
          }
          catch (e) {
            return null;
          }
      },
      allowanceMileages() {
          if(this.metadata){
  
              if(this.metadata.adjustments.adjustment)
                  var obj = this.metadata.adjustments.adjustment;
              else
                  var obj = this.metadata.adjustments;
  
              var allowedMileages = {};
  
              for (const prop in obj)
                  allowedMileages[prop] = obj[prop]["mileage"];
              
              this.kilometersAllowance = allowedMileages[0];
              return allowedMileages;
  
          }else
              return null;
      },
      residual() {
        if (!this.isLease)
          return 0;
  
        const index = this.lease.map(item => { return item.term }).indexOf(this.loanTerm);
        if (index == -1)
          return 0;
  
        var metadata = null;
        try {
          metadata = this.lease[index].metadata;
          return this.salePrice * (parseFloat(JSON.parse(metadata).residual.value) + this.leaseAdjustment) / 100;
        }
        catch (e) {
          return 0;
        }
      },
      remainingVehiclePrice() {
        var downPaymentN;
        var tradeInValueN;
       
  
        if (this.downPayment) {
          downPaymentN = (this.downPayment.length > 0) ? parseInt(this.downPayment) : 0;
        } else {
          downPaymentN = 0;
        }
  
        if (this.tradeInValue) {
          tradeInValueN = (this.tradeInValue.length > 0) ? parseInt(this.tradeInValue) : 0;
        } else {
          tradeInValueN = 0;
        }
  
        this.$cookies.set('downPayment', downPaymentN);
        this.$cookies.set('tradeInValue', tradeInValueN);
  
        var vehiclePrice = parseInt(this.vehiclePrice);
        var result = vehiclePrice;
        if(tradeInValueN || downPaymentN) {
          if (tradeInValueN) {
            result = result - tradeInValueN;
          } 
    
          if (downPaymentN) {
            result = (result) -  (downPaymentN / this.provinceTaxValue) ;
          } 
        }
        else{
          //result = (result * this.provinceTaxValue);
        }
        
  
        return result;
      },
      selectedMethod() {
        if (this.isLease)
          return this.lease;
        else
          return this.finance;
      },
      terms() {
        var duplicatedMonths = this.selectedMethod.map(item => { return { term: item.term, value: item.value } });
        var visited = [];
        var months = duplicatedMonths.filter(item => {
          if (visited.indexOf(item.term) == -1) {
            visited.push(item.term);
            return item;
          }
        })
        if (months == null) {
          return [];
        }
        return months
      },
      termsOptions() {
        return this.terms.sort((a, b) => a.term - b.term).map(item => { return item.term });
      },
    },
    watch: {
      remainingVehiclePrice() {
        this.calculatePayment();
      }
    },
    filters: {
  
    },
    beforeMount() {
      this.calculatePayment()
    },
    created() {
      if (this.finance.length == 0)
        this.finance = this.termsMock;
      if (this.lease.length == 0)
        this.lease = this.termsMock;
  
      this.loanTerm = this.termsOptions[this.termsOptions.length - 1];
      this.setInterestRate();
    },
  }